;$(function() {

    $('.input-clear').click(function() {
        $(this).prev()[0].value = null;
    });

});